// A stage-body card whose head carries a node beside its title (a TARP chip,
// the draft pill) with no separator dot — comp A's `.card > .hd`. It is the
// `SurfacePagePanel` recipe (matte card, head on a hairline, flush body) with a
// title node; every other stage body keeps `SurfacePagePanel` (polish.P28c).

import type { ReactNode } from 'react';
import { cn } from '@/shared/cn';
import { SURFACE_PAGE_META, SURFACE_PAGE_SECTION_TITLE } from '@/shared/ui-class';

export function StageCard({
  title,
  beside,
  meta,
  actions,
  className,
  bodyClassName,
  children,
  ...rest
}: {
  title: string;
  /** Rides on the title's line, after it (a chip or a pill). */
  beside?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
} & Record<`data-${string}`, string | undefined>) {
  return (
    <section className={cn('card-matte-2 flex min-w-0 flex-col', className)} {...rest}>
      <div className="hairline-b px-4 pb-2.5 pt-3">
        <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
          <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
            <h2 className={SURFACE_PAGE_SECTION_TITLE}>{title}</h2>
            {beside}
          </div>
          {meta || actions ? (
            <div className="flex flex-wrap items-center gap-3">
              {meta ? <div className={SURFACE_PAGE_META}>{meta}</div> : null}
              {actions}
            </div>
          ) : null}
        </div>
      </div>
      <div className={cn('min-h-0 flex-1 pb-1', bodyClassName)}>{children}</div>
    </section>
  );
}
